import { SET_CURRENT_PLAYING_ANIMATION } from "./types";

export const setCurrentPlayingAnimation = (animation) => ({
  type: SET_CURRENT_PLAYING_ANIMATION,
  payload: animation,
});
